<awakening-selector title="{{title | translate}}"
                    disclaimer="{{disclaimer | translate}}"
                    selectedSegment="{{selectedSegment}}"
                    [segments]="segments"
                    (selected-segment-changed)="setSelectedSegment($event)"></awakening-selector>